import React from 'react';
import { motion } from 'framer-motion';

const ProductList = () => {
  const fontStyle = {
    fontFamily: '"Poetsen One", sans-serif',
    fontWeight: 'normal',
  };

  const fadeInUp = {
    initial: { opacity: 0, y: 40 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
  };

  const products = [
    {
      title: 'Coconut Oil',
      tagline: 'Pure. Fresh. Natural.',
      desc: 'Extracted from Dried copra, our coconut oil retains its natural flavor and aroma. Ideal for cooking, cosmetics, and wellness, this oil is chemical-free and traditionally crafted.',
      img: 'https://gallerypng.com/wp-content/uploads/2024/10/Coconut-Oil-Png-Picture-Free-730x750.png',
    },
    {
      title: 'Coconut Shell Charcoal',
      tagline: 'Clean Heat Energy',
      desc: 'Sustainably processed charcoal from coconut shells—used for BBQ, industry, and purification.',
      img: 'https://res.cloudinary.com/dwf8ifbzs/image/upload/v1745153612/OIP_18_klc8kf.jpg',
    },
    {
      title: 'Poonac',
      tagline: 'Protein-Rich Feed',
      desc: 'A nutritious by-product of coconut oil extraction, widely used in cattle and livestock feed.',
      img: 'https://res.cloudinary.com/dwf8ifbzs/image/upload/v1744880684/WhatsApp_Image_2025-04-17_at_10.00.17_AM_hv1xt4.jpg',
    },
    {
      title: 'Copra (Dried Coconut)',
      tagline: 'Sun-Dried Purity',
      desc: 'Carefully dried coconut kernels used in oil extraction and food applications.',
      img: 'https://res.cloudinary.com/dwf8ifbzs/image/upload/v1745154261/OIP_19_p9g5js.jpg',
    },
    {
      title: 'Dhal Husk (පරිප්පු පොතු / ඔමි)',
      tagline: 'Daily Fiber Boost',
      desc: 'A natural fiber source to aid digestion and roughage intake in animals.',
      img: 'https://res.cloudinary.com/dwf8ifbzs/image/upload/v1744880767/WhatsApp_Image_2025-04-17_at_11.10.18_AM_2_gz7qrr.jpg',
    },
    {
      title: 'Beer Waste (බියර් පොතු)',
      tagline: 'Fermented Growth Power',
      desc: 'Rich in vitamins and nutrients—ideal for animal weight gain and digestion.',
      img: 'https://res.cloudinary.com/dwf8ifbzs/image/upload/v1745036832/WhatsApp_Image_2025-04-17_at_4.03.53_PM_xdfuyo.jpg',
    },
    {
      title: 'Animal Vitamins & Supplements (Minamax-plus)',
      tagline: 'Vital Support Mix',
      desc: 'Supplementary nutrients that support health, energy, and productivity.',
      img: 'https://res.cloudinary.com/dwf8ifbzs/image/upload/v1745048681/MInamax_rtkedf.jpg',
    },
    {
      title: 'Animal Vitamins & Supplements (Aminol-HP)',
      tagline: 'Vital Support Mix',
      desc: 'Supplementary nutrients that support health, energy, and productivity.',
      img: 'https://res.cloudinary.com/dwf8ifbzs/image/upload/v1745037380/WhatsApp_Image_2025-04-17_at_4.03.55_PM_1_glrfna.jpg',
    },
  ];

  return (
    <motion.div
      className="container mx-auto mt-10 px-4 sm:px-6 md:px-10 py-10"
      {...fadeInUp}
      transition={{ delay: 0.4 }}
    >
      <h2
        className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold leading-tight bg-gradient-to-r from-green-600 to-yellow-400 bg-clip-text text-transparent text-center"
        style={fontStyle}
      >
        Our Products
      </h2>

      <p
        className="text-center text-sm sm:text-base md:text-lg xl:text-xl mt-4 mb-10 text-gray-700"
        style={fontStyle}
      >
        Naturally produced. Trusted for generations. Explore our high-quality coconut-based and animal feed products,
        manufactured with care and commitment to purity and sustainability.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-10 gap-x-6">
        {products.map((product, i) => (
          <motion.div
            key={i}
            className="rounded-xl overflow-hidden bg-white/90 shadow-lg border border-gray-200 hover:shadow-xl transform hover:scale-105 transition-transform duration-300"
            {...fadeInUp}
            transition={{ delay: i * 0.1 }}
          >
            <img
              src={product.img}
              alt={product.title}
              className="w-full h-48 sm:h-52 md:h-56 lg:h-60 xl:h-64 object-cover"
            />
            <div className="p-4">
              <h4 className="text-lg sm:text-xl font-semibold text-green-800 mb-1" style={fontStyle}>
                {product.title}
              </h4>
              <p className="text-xs sm:text-sm italic text-yellow-700 mb-2">{product.tagline}</p>
              <p className="text-xs sm:text-sm text-gray-700 text-center sm:text-justify" style={fontStyle}>
                {product.desc}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default ProductList;
